import React from 'react';
import ReactDOM from 'react-dom/client';

/* ── Vendor styles ─────────────────────────────────────────── */
import 'bootstrap/dist/css/bootstrap.min.css';

/* ── Brand design system ──────────────────────────────────── */
import './styles/theme.css';  /* CSS custom properties / tokens */
import './styles/global.css'; /* Global reset, utilities, components */
import './styles/modern.css'; /* Dark futuristic layer + motion utilities */
import './styles/conversion.css'; /* Lead capture, content blocks, floating contact */

/* ── Application entry point ─────────────────────────────── */
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
